'use strict';
const mmWidgets = require('./mm-widgets'),
	teamProviderClass = require('./team-provider-class');

mmWidgets.fn.goldMapSharedWithWidget = function (shareItem, sharingRole, mapSharingModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			removeButton = element.find('[data-mm-role~="remove-sharing-item"]');
		element.find('[data-mm-role~="share-description"]').text(shareItem.description);
		element.find('[data-mm-role~="share-role"]').text(sharingRole || 'shared');
		if (shareItem.group === 'subteam' || shareItem.affiliateProvider) {
			element.find('[data-mm-role~="team-provider"]').addClass(teamProviderClass(shareItem.affiliateProvider));
		}
		if (shareItem && shareItem.allowedActions && shareItem.allowedActions.includes('unshare-map') && sharingRole !== 'team access') {
			removeButton.click(() => {
				if (element.hasClass('disabled')) {
					return;
				}
				mapSharingModel.removeSharing(shareItem);
				element.remove();
			});
		} else {
			removeButton.remove();
		}
	});
};
